export const AUTO_MODE_STORAGE_KEY = "breacher.auto-mode";

export function readAutoModePreference(): boolean {
  try {
    return localStorage.getItem(AUTO_MODE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeAutoModePreference(enabled: boolean): void {
  try {
    localStorage.setItem(AUTO_MODE_STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    // Storage may be unavailable; the current session can still use the toggle.
  }
}
